import { render } from "./TeamGrid.vue?vue&type=template&id=bca69ebe&scoped=true"
import script from "./TeamGrid.vue?vue&type=script&lang=js"
export * from "./TeamGrid.vue?vue&type=script&lang=js"

import "./TeamGrid.vue?vue&type=style&index=0&id=bca69ebe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bca69ebe"

export default script